/**
 * Created by rathompson on 7/26/22
 * File: APITableCell
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Body, Checkbox, Tooltip } from '@panwds/react-ui'
import { Line } from '../../../../common/assets/images'
import { useTableInstance } from '@panwds/react-table'
import { useContext, useMemo } from 'react'
import AppContext from '../../../../common/context/AppContext'
import styled from 'styled-components'
import { LockIcon } from '@panwds/icons'
import RowExpansionToggle from './RowExpansionToggle'
import IAMAppName from '../../../utils/IAMAppName'

const BODY = styled.div`
  overflow: hidden;
  direction: rtl;
`
const CheckboxWrapper = styled.div`
  label {
    margin: 0;
  }
`

const PermissionCell = ({ row, value, enableRowSelect, onSelect }) => {

  const { getAppName } = useContext(AppContext)

  const padding = 20 * row?.depth
  const locked = row?.original?.locked
  const className = 'tw-flex tw-items-center tw-overflow-hidden tw-py-1'

  const tableRef = useTableInstance()

  const isParentSelected = useMemo(() => {
    if (row?.original?.parent) {
      const parent = tableRef?.flatRows?.find(r => r?.original?.name === row?.original?.parent.name)
      return !!tableRef?.state?.selectedRowIds[parent?.id]
    }
    return false
  }, [row, tableRef])

  return (
    <div className={className}>
      {enableRowSelect && (
        <div className='tw-pr-4'>
          {!!locked ? (
            <Tooltip label={'This permission is not editable because it’s being defined by Web UI permissions.'}>
              <div><LockIcon className='tw-text-disabled' size='sm'/></div>
            </Tooltip>
          ) : (
            <CheckboxWrapper>
              <Checkbox checked={row?.isSelected} disabled={isParentSelected} onChange={() => onSelect(row)}/>
            </CheckboxWrapper>
          )}
        </div>
      )}
      <div className='tw-flex tw-items-center tw-overflow-hidden' style={{ paddingLeft: `${padding}px` }}>
        {!row?.canExpand && <div style={{ width: '20px' }}/>}
        {!!row?.depth && <img style={{ width: '10px', height: '10px' }} src={Line} alt={'line'} />}
        {!!row?.canExpand && <RowExpansionToggle row={row}/>}
        <BODY>
          <Body size='lg' truncate addClassName='tw-w-full tw-truncate'>{IAMAppName(value, getAppName)}</Body>
        </BODY>
      </div>
    </div>
  )
}

PermissionCell.propTypes = {}
export default PermissionCell
